/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import '../../config';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import 'typeface-roboto';
import _ from 'lodash';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Snackbar from '@material-ui/core/Snackbar';

const useStyles = makeStyles({
  cardWrapper: {
    marginBottom: 5,
  }
});

const OrderInformasiKurir = (props) => {
  const classes = useStyles();
  const { data } = props;
  const [toast, setToast] = React.useState(false);

  const handleCopy = () => {
    if (!_.isEmpty(data.order_shipping_code)) {
      setToast(true);
    }
  };

  const handleToastClose = () => {
    setToast(false);
  };

  return (
    <Card className={classes.cardWrapper}>
      <CardActionArea >
        <CopyToClipboard text={data.order_shipping_code} onCopy={handleCopy}>
          <CardContent>
            <Grid container spacing={2} justify="space-between">
              <Grid item>
                <Typography className={classes.label} variant="button">NOMOR RESI</Typography>
              </Grid>
              <Grid item>
                <Typography className={classes.label} variant="button">{data.order_shipping_code}</Typography>
              </Grid>
            </Grid>
          </CardContent>
        </CopyToClipboard>
      </CardActionArea>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={toast}
        autoHideDuration={2000}
        onClose={handleToastClose}
        message="Nomor Rekening dicopy ke Clipboard"
        severity="success"
      />
    </Card>
  );
};

export default OrderInformasiKurir;
